import {v4 as randomUUID} from 'uuid';

export const initialState = {
  firstName: {
    value: '',
    hasError: true,
    errorMessage: ''
  },
  lastName: {
    value: '',
    hasError: true,
    errorMessage: ''
  },
  dateOfBirth: {
    month: {value: '', hasError: true, errorMessage: ''},
    day: {value: '', hasError: true, errorMessage: ''},
    year: {value: '', hasError: true, errorMessage: ''},
    errorMessage: {value: '', hasError: true},
    value: ''
  },
  streetAddress: {value: '', hasError: true, errorMessage: ''},
  apartment: {value: '', hasError: true, errorMessage: ''},
  city: {value: '', hasError: true, errorMessage: ''},
  stateOrProvince: {value: '', hasError: true, errorMessage: ''},
  postalCode: {value: '', hasError: true, errorMessage: ''},
  income: {value: '', hasError: true, errorMessage: ''},
  selectedVehicle: {
    year: {value: ''},
    model: {value: '', displayName: ''},
    trim: {value: ''},
    make: {value: ''},
    value: false
  },
  cardEditFlags: {
    personalInfoEditMode: {value: false},
    incomeEditMode: {value: false},
    residenceEditMode: {value: false},
    vehicleEditMode: {value: false}
  },
  email: {
    value: '',
    hasError: true,
    errorMessage: '',
    dealerSubmissionErrorMessage: ''
  },
  softInquiryConsent: {value: false},
  acceptedTermsAndConditions: {value: false},
  fordHeaderFooterLoading: {value: false},
  highestPageHit: {value: 0},
  decisionCode: {value: ''},
  conversationId: {value: ''},
  rate: {value: ''},
  totalApprovedAmount: {value: 0},
  expirationDate: {value: ''},
  phoneNumber: {value: '', hasError: false, errorMessage: ''},
  toggleDealerSubmissionDialog: {value: false},
  toggleDealerConnectDialog: {value: false},
  showPreQualificationAmount: {value: true},
  preferredContactMethod: {value: 'Email'},
  dealerNotes: {value: ''},
  selectedDealer: {value: {}},
  toggleDealerConfirmationPage: {value: false},
  DealerConfirmationWithoutMapFeatureFlag: {value: false},
  dealerSearchString: {value: '', hasError: false, errorMessage: ''},
  dealerSearchType: {value: ''},
  dealerLeadSubmitted: {value: false},
  showCancelPreQualModal: {value: false},
  dealerLeadStatusMessage: {value: ''},
  isSelected: {value: true},
  uuid: randomUUID(),
  showModalFlag: {value: false},
  currentModalPage: {value: ''},
  isDealerHostApplication: {value: false},
  tier3PACode: {value: ''},
  tier3Vin: {value: ''},
  result: {value: {}},
  indexSource: {value: 'web'},
  prequalSource: {value: 'web'},
  specialEvent: {value: false},
  skipAddressStandardization: {value: false},
  optimizelyExperimentData: {},
  loadingPageTagged: false,
  canadaInputValidationFlag: false,
  countryCode: {value: 'USA'},
  modalUpdateFlag: true,
  languageCode: 'EN',
  config: {},
  recaptchaOptimizelyData: {}
};
